/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import { token } from '@atlaskit/tokens';
import imgSVG from './assets/capacity-app-skeleton.tpl.svg';
import embedImgSVG from './assets/capacity-embed-app-skeleton.tpl.svg';
import noHeaderImgSVG from './assets/capacity-no-header-skeleton.tpl.svg';
import headerOnlyImgSVG from './assets/capacity-header-only-skeleton.tpl.svg';
import withHeaderImgSVG from './assets/capacity-with-header-skeleton.tpl.svg';

export const CapacitySkeleton = (): JSX.Element => (
	<AppSkeletonImage src={imgSVG} css={styles.compensateTemplateBorder} />
);

export const CapacityEmbedSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={embedImgSVG} css={styles.compensateTemplateBorder} />
);

export const CapacityNoHeaderSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={noHeaderImgSVG} css={[styles.noBorder, styles.compensateTemplateBorder]} />
);

export const CapacityHeaderOnlySkeleton = (): JSX.Element => (
	<AppSkeletonImage
		src={headerOnlyImgSVG}
		css={[styles.noBorder, styles.compensateTemplateBorder]}
		containerStyles={{ height: '44px', flexShrink: 0 }}
	/>
);
export const CapacityWithHeaderSkeleton = (): JSX.Element => (
	<AppSkeletonImage
		src={withHeaderImgSVG}
		css={[styles.noBorder, styles.compensateTemplateBorder]}
	/>
);

export const EntryPointCapacityWithHeaderSkeleton = (): JSX.Element => (
	<div css={styles.entryPointStyles}>
		<CapacityWithHeaderSkeleton />
	</div>
);

const styles = cssMap({
	// AppSkeletonImage has borderLeftWidth: 40px which messes up skeleton alignment with the aftercoming content.
	compensateTemplateBorder: {
		borderLeftWidth: 0,
		borderRightWidth: 0,
		'@media (min--moz-device-pixel-ratio: 2)': {
			borderLeftWidth: 0,
			borderRightWidth: 0,
		},
	},
	// Keep in sync with the wrapper in SoftwareCapacityContainer.
	entryPointStyles: {
		paddingBlock: token('space.300'),
		paddingInlineStart: token('space.300'),
		flexGrow: 1,
		overflow: 'hidden',
		height: '100%',
	},
	noBorder: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'&&': {
			border: 'none',
		},
	},
});
